import { connect, MapStateToProps } from 'react-redux';
import { StageBackgroundProps } from './types';
import { getBackground } from '../redux/selectors';
import { DeviationBackgroundStoreSlice } from '../redux/types';

export type StateProps = Pick<StageBackgroundProps, 'background'>;
export type OwnProps = Omit<StageBackgroundProps, keyof (StateProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  DeviationBackgroundStoreSlice
> = (state, ownProps) => ({
  background: getBackground(state, ownProps.deviation),
});

export default connect(mapStateToProps);
